module.exports = __webpack_public_path__ + "static/media/logo.d7fa3d2a.png";